export default __webpack_public_path__ + "static/media/694.918e7e8b.png";